// @flow

import { shouldUpdate } from 'recompose';
import { isEqual, negate } from 'lodash';

const havePropsReallyChanged = negate(isEqual);

export default shouldUpdate(havePropsReallyChanged);
